function nested() {
    const nav = document.querySelector('.gh-footer-menu');
    if (!nav) return;

    const logo = document.querySelector('.gh-navigation-logo');
    const items = nav.querySelectorAll('li');
    let itemIndex = {};
    let currentParentItem;

    items.forEach(function (item, index) {
      const classString = Array.from(item.classList).join(' ');

      if (classString.includes('has_child')) {
        currentParentItem = index;
        itemIndex[index] = {elements: [], item: item};
      }
      else if (classString.includes('subitem') && currentParentItem !== null && itemIndex[currentParentItem]) {
        itemIndex[currentParentItem].elements.push(item);
        item.remove();
      }
    });

    const makeNested = function () {
      let submenuItems = [];

      for (let itemKey in itemIndex) {
        let item = itemIndex[itemKey].item;
        let contentDiv = item.children[0];
        let aDiv = contentDiv.children[0];
        aDiv.innerHTML = aDiv.innerHTML.replace('[has_child]', '');
        aDiv.href = 'javascript:void(0)';
        aDiv.classList.add('gh-has-nested');

        const wrapper = document.createElement('ul');
        wrapper.setAttribute('class', 'gh-nested');

        itemIndex[itemKey].elements.forEach(function (child) {
          child.innerHTML = child.innerHTML.replace('[subitem]', '');
          wrapper.appendChild(child);
        });

        item.appendChild(wrapper);

      }

      nav.classList.add('is-nested-loaded');
    }

    imagesLoaded(logo, function () {
        makeNested();
    });

    window.addEventListener('load', function () {
        if (!logo) {
            makeNested();
        }
    });
}
